module.exports = __webpack_public_path__ + "static/zqb-lite.a0db87f1.png";